import { render, staticRenderFns } from "./Pair.vue?vue&type=template&id=16e7224b&scoped=true"
import script from "./Pair.vue?vue&type=script&lang=js"
export * from "./Pair.vue?vue&type=script&lang=js"
import style0 from "./Pair.vue?vue&type=style&index=0&id=16e7224b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e7224b",
  null
  
)

export default component.exports